import Styles from "./timedown.module.scss";
import Countdown from "react-countdown";

const TimeDown = ({ datetime = new Date(), noText = false, responsive = false, callback }) => {
  const handleExpire = () => {};
  return (
    <>
      <div className={Styles.counterdowm}>
        <Countdown
          date={datetime || new Date()}
          precision={3}
          renderer={({ days, hours, minutes, seconds, completed, total }) => (
            <>
              {completed ? (
                <>پایان یافته</>
              ) : (
                <div className={Styles.rowCounter}>
                  <div className={`${Styles.item} ${responsive && Styles.has}`}>
                    <div className={Styles.holdCount}>
                      <div className={Styles.holdDigit}>{seconds || 0}</div>
                      {!noText && <div className={Styles.holdLabel}>ثانیه</div>}
                    </div>
                    <div className={Styles.divider}>:</div>
                  </div>

                  <div className={`${Styles.item} ${responsive && Styles.has}`}>
                    <div className={Styles.holdCount}>
                      <div className={Styles.holdDigit}>{minutes || 0}</div>
                      {!noText && <div className={Styles.holdLabel}>دقیقه</div>}
                    </div>
                    <div className={Styles.divider}>:</div>
                  </div>

                  <div className={`${Styles.item} ${responsive && Styles.has}`}>
                    <div className={Styles.holdCount}>
                      <div className={Styles.holdDigit}>{hours || 0}</div>
                      {!noText && <div className={Styles.holdLabel}>ساعت</div>}
                    </div>
                    <div className={Styles.divider}>:</div>
                  </div>

                  <div className={`${Styles.item} ${responsive && Styles.has}`}>
                    <div className={Styles.holdCount}>
                      <div className={Styles.holdDigit}>{days || 0}</div>
                      {!noText && <div className={Styles.holdLabel}>روز</div>}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        />
      </div>
    </>
  );
};

export default TimeDown;
